import React from 'react';

import { Box } from '@chakra-ui/react';

import {
  OutlinedFormCustomWithLabelField,
  OutlinedFormFieldComponentProps,
} from '../types';

import { FieldContainer } from './FieldContainer';

export const CustomWithLabelField = ({
  field,
  styles,
}: OutlinedFormFieldComponentProps<OutlinedFormCustomWithLabelField>) => (
  <FieldContainer
    fieldStyles={field.styles}
    isDisabled={field.isDisabled}
    label={field.label}
    styles={styles}
  >
    <Box mt={1} {...styles?.value} {...field.styles?.value}>
      {field.component}
    </Box>
  </FieldContainer>
);
